import { useEffect } from 'react';

interface UseCloseOnLockedOptions {
  isLocked: boolean;
  submitCount: number;
  onClose?: () => void;
}

export function useCloseOnLocked({
  isLocked,
  submitCount,
  onClose,
}: UseCloseOnLockedOptions) {
  useEffect(() => {
    if (isLocked && submitCount > 0) {
      onClose?.();
    }
  }, [isLocked, submitCount, onClose]);
}
